/* ==========================================================================
   EdibleInkStore — consumable PDP: multi-select variant picker
   Progressive enhancement. Without JS the section falls back to the
   single-variant <form> Shopify renders inside <noscript>.
   ========================================================================== */
(function () {
  "use strict";

  var TICK =
    '<svg viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.2l2.4 2.4L9.5 3.6"/></svg>';

  /* Fallback bottle illustration, tinted per variant, used when a variant
     has no image of its own. Keeps the page presentable before photography. */
  function bottleSVG(ink, style) {
    var dark = "#2B2431";
    return (
      '<svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"' +
      (style ? ' style="' + style + '"' : "") + ">" +
      '<rect x="44" y="6" width="32" height="20" rx="4" fill="' + dark + '"/>' +
      '<rect x="49" y="24" width="22" height="12" fill="' + dark + '" opacity=".85"/>' +
      '<path d="M38 44c0-5 4-8 9-9l4-1v-2h18v2l4 1c5 1 9 4 9 9v134c0 6-4 10-10 10H48c-6 0-10-4-10-10z" fill="' + ink + '"/>' +
      '<path d="M38 44c0-5 4-8 9-9l4-1v-2h6v156H48c-6 0-10-4-10-10z" fill="#fff" opacity=".16"/>' +
      '<rect x="38" y="96" width="44" height="44" fill="#FFF9FB" opacity=".93"/>' +
      '<rect x="45" y="106" width="30" height="3.5" rx="1.75" fill="' + dark + '" opacity=".65"/>' +
      '<rect x="45" y="114" width="20" height="3" rx="1.5" fill="' + dark + '" opacity=".35"/>' +
      '<rect x="45" y="124" width="26" height="6" rx="1" fill="' + ink + '"/>' +
      '<path d="M38 178v10c0 6 4 10 10 10h24c6 0 10-4 10-10v-10z" fill="' + dark + '" opacity=".14"/>' +
      "</svg>"
    );
  }

  var SET_INKS = ["#1D1B20", "#19A6C6", "#D63C84", "#F0C22B"];

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function init(root) {
    if (root.dataset.eisReady === "true") return;
    root.dataset.eisReady = "true";

    var dataEl = root.querySelector("[data-eis-data]");
    if (!dataEl) return;

    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var VARIANTS = cfg.variants || [];
    if (!VARIANTS.length) return;

    var moneyFormat = cfg.moneyFormat || "${{amount}}";
    var threshold = cfg.freeShipping || 0;      // in cents, 0 disables the meter
    var cartUrl = cfg.cartUrl || "/cart";

    var swWrap = root.querySelector("[data-eis-swatches]");
    var linesEl = root.querySelector("[data-eis-lines]");
    var totalEl = root.querySelector("[data-eis-total]");
    var shipEl = root.querySelector("[data-eis-ship]");
    var barEl = root.querySelector("[data-eis-bar]");
    var atc = root.querySelector("[data-eis-atc]");
    var errEl = root.querySelector("[data-eis-error]");
    var stage = root.querySelector("[data-eis-stage]");

    if (!swWrap || !atc) return;

    var picked = new Map();          // variant id -> quantity
    var byId = {};
    VARIANTS.forEach(function (v) { byId[v.id] = v; });

    /* Shopify money formatting, cents in. Handles the four standard tokens. */
    function money(cents) {
      var v = (cents / 100);
      function fmt(dec, sep, group) {
        var parts = v.toFixed(dec).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, group);
        return parts.join(sep || ".");
      }
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, token) {
        switch (token) {
          case "amount": return fmt(2, ".", ",");
          case "amount_no_decimals": return fmt(0, ".", ",");
          case "amount_with_comma_separator": return fmt(2, ",", ".");
          case "amount_no_decimals_with_comma_separator": return fmt(0, ",", ".");
          default: return fmt(2, ".", ",");
        }
      });
    }

    function maxFor(v) {
      // Respect inventory only when Shopify is tracking it and refuses oversell.
      if (v.tracked && v.policy === "deny") return Math.max(0, v.inventory);
      return 99;
    }

    function media(v, cls) {
      if (v.image) {
        return '<img src="' + esc(v.image) + '" alt="' + esc(v.title) + '" loading="lazy">';
      }
      if (v.isSet) {
        return '<span class="quad">' + SET_INKS.map(function (c) {
          return bottleSVG(c, "height:40px");
        }).join("") + "</span>";
      }
      return bottleSVG(v.ink || "#9AA1A8");
    }

    /* ---------- build the cards ---------- */
    swWrap.innerHTML = VARIANTS.map(function (v) {
      var cap = maxFor(v);
      var low = v.tracked && v.policy === "deny" && v.inventory > 0 && v.inventory <= 10;
      return (
        '<div class="eis-c__sw" data-id="' + v.id + '" data-selected="false" ' +
          'data-available="' + (v.available ? "true" : "false") + '" data-max="' + cap + '">' +
          '<span class="tick" aria-hidden="true">' + TICK + "</span>" +
          (v.compareAt > v.price
            ? '<span class="flagpin">Save ' + money(v.compareAt - v.price) + "</span>"
            : "") +
          '<button class="eis-c__pick" type="button" data-pick ' +
            'aria-pressed="false"' + (v.available ? "" : " disabled") +
            ' aria-label="' + esc(v.title) + ", " + money(v.price) + '">' +
            '<span class="mini">' + media(v) + "</span>" +
            '<span class="cap">' + esc(v.title) + "</span>" +
            '<span class="amt">' + (v.available ? money(v.price) : "Sold out") + "</span>" +
            (low ? '<span class="left">' + v.inventory + " left</span>" : "") +
          "</button>" +
          '<div class="eis-c__qty">' +
            '<button type="button" data-step="-1" aria-label="One fewer ' + esc(v.title) + '">&minus;</button>' +
            '<input type="text" data-count value="1" data-eis-ignore ' +
              'inputmode="numeric" autocomplete="off" ' +
              'aria-label="' + esc(v.title) + ' quantity">' +
            '<button type="button" data-step="1" aria-label="One more ' + esc(v.title) + '">+</button>' +
          "</div>" +
        "</div>"
      );
    }).join("");

    /* ---------- gallery mirrors the selection ---------- */
    function paintStage() {
      if (!stage || stage.dataset.hasPhoto === "true") return;
      var inks = [];
      picked.forEach(function (_, id) {
        var v = byId[id];
        if (v.isSet) { inks = inks.concat(SET_INKS); }
        else if (v.ink) { inks.push(v.ink); }
      });
      if (!inks.length) inks = [VARIANTS[0].ink || "#1D1B20"];
      var seen = inks.filter(function (c, i) { return inks.indexOf(c) === i; }).slice(0, 5);
      var w = 120 * seen.length;
      stage.innerHTML =
        '<svg viewBox="0 0 ' + w + ' 200" aria-hidden="true">' +
        seen.map(function (c, i) {
          return '<g transform="translate(' + i * 120 + ',0)">' +
            bottleSVG(c).replace(/<\/?svg[^>]*>/g, "") + "</g>";
        }).join("") + "</svg>";
    }

    /* ---------- render ---------- */
    function render() {
      var total = 0, units = 0;

      Array.prototype.forEach.call(swWrap.querySelectorAll(".eis-c__sw"), function (card) {
        try {
        var id = card.dataset.id;
        var on = picked.has(id);
        card.dataset.selected = on ? "true" : "false";
        card.querySelector("[data-pick]").setAttribute("aria-pressed", on ? "true" : "false");
        var box = card.querySelector("[data-count]");
        if (box && on && document.activeElement !== box) box.value = picked.get(id);
        } catch (e) { /* a theme script may have replaced this card's input */ }
      });

      var rows = [];
      picked.forEach(function (n, id) {
        var v = byId[id];
        total += v.price * n;
        units += n;
        var chip = v.isSet
          ? '<span class="dot" style="background:linear-gradient(135deg,' +
            SET_INKS[0] + " 0 25%," + SET_INKS[1] + " 25% 50%," +
            SET_INKS[2] + " 50% 75%," + SET_INKS[3] + ' 75%)"></span>'
          : '<span class="dot" style="background:' + (v.ink || "#9AA1A8") + '"></span>';
        rows.push(
          '<div class="eis-c__line">' +
            '<span class="nm">' + chip + esc(v.title) +
              '<span class="qn">&times;' + n + "</span></span>" +
            '<span class="amt">' + money(v.price * n) + "</span>" +
            '<button type="button" data-remove="' + id + '" ' +
              'aria-label="Remove ' + esc(v.title) + '">&times;</button>' +
          "</div>"
        );
      });

      linesEl.innerHTML = rows.length
        ? '<div class="eis-c__lines">' + rows.join("") + "</div>"
        : '<p class="eis-c__empty">Nothing picked yet — tap a bottle above.</p>';

      if (totalEl) totalEl.textContent = money(total);

      if (threshold > 0 && shipEl && barEl) {
        var short = threshold - total;
        var met = short <= 0;
        barEl.classList.toggle("is-met", met);
        shipEl.classList.toggle("is-met", met);
        barEl.firstElementChild.style.width =
          Math.min(100, (total / threshold) * 100) + "%";
        shipEl.textContent = met
          ? "Free ground shipping unlocked."
          : "Add " + money(short) + " more for free ground shipping.";
      }

      atc.disabled = units === 0;
      atc.textContent = units === 0
        ? "Select a colour to continue"
        : "Add " + units + (units === 1 ? " item" : " items") + " to cart — " + money(total);

      paintStage();
    }

    /* ---------- interactions ---------- */
    swWrap.addEventListener("click", function (e) {
      var card = e.target.closest(".eis-c__sw");
      if (!card || card.dataset.available === "false") return;
      var id = card.dataset.id;
      var cap = parseInt(card.dataset.max, 10) || 99;

      if (e.target.closest("[data-pick]")) {
        picked.has(id) ? picked.delete(id) : picked.set(id, 1);
      } else {
        var step = e.target.closest("[data-step]");
        if (!step) return;
        var n = (picked.get(id) || 0) + parseInt(step.dataset.step, 10);
        n < 1 ? picked.delete(id) : picked.set(id, Math.min(cap, n));
      }
      if (errEl) errEl.textContent = "";
      render();
    });

    /* Typing a quantity: 5 yellow without five taps. */
    swWrap.addEventListener("input", function (e) {
      var box = e.target.closest("[data-count]");
      if (!box) return;
      var card = box.closest(".eis-c__sw");
      var id = card.dataset.id;
      var cap = parseInt(card.dataset.max, 10) || 99;
      var raw = box.value.replace(/\D/g, "");
      if (raw === "") return;                 // mid-edit, wait for blur
      var n = Math.min(cap, parseInt(raw, 10));
      n < 1 ? picked.delete(id) : picked.set(id, n);
      render();
    });

    swWrap.addEventListener("blur", function (e) {
      var box = e.target.closest("[data-count]");
      if (!box) return;
      var id = box.closest(".eis-c__sw").dataset.id;
      if (picked.has(id)) box.value = picked.get(id);   // tidy "" and "007"
    }, true);

    swWrap.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target.closest("[data-count]")) {
        e.preventDefault();
        e.target.blur();
      }
    });

    linesEl.addEventListener("click", function (e) {
      var x = e.target.closest("[data-remove]");
      if (!x) return;
      picked.delete(x.dataset.remove);
      render();
    });

    /* ---------- add everything in one request ---------- */
    atc.addEventListener("click", function () {
      if (!picked.size || atc.disabled) return;

      var items = [];
      picked.forEach(function (n, id) {
        items.push({ id: parseInt(id, 10), quantity: n });
      });

      atc.setAttribute("aria-busy", "true");
      atc.disabled = true;
      if (errEl) errEl.textContent = "";

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + "cart/add.js"
              : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || "Could not add to cart.");
            return body;
          });
        })
        .then(function () {
          picked.clear();
          // Let the theme's cart drawer refresh itself if it listens for this.
          document.dispatchEvent(new CustomEvent("eis:cart:updated", { bubbles: true }));
          if (cfg.redirectToCart) {
            window.location.href = cartUrl;
          } else {
            render();
            if (errEl) errEl.textContent = "";
          }
        })
        .catch(function (err) {
          if (errEl) errEl.textContent = err.message;
        })
        .finally(function () {
          atc.removeAttribute("aria-busy");
          render();
        });
    });

    /* ---------- gallery thumbs ---------- */
    Array.prototype.forEach.call(root.querySelectorAll("[data-eis-thumb]"), function (t) {
      t.addEventListener("click", function () {
        Array.prototype.forEach.call(root.querySelectorAll("[data-eis-thumb]"), function (x) {
          x.setAttribute("aria-pressed", "false");
        });
        t.setAttribute("aria-pressed", "true");
        var src = t.dataset.full;
        if (src && stage) {
          stage.dataset.hasPhoto = "true";
          stage.innerHTML = '<img src="' + esc(src) + '" alt="">';
        }
      });
    });

    /* ---------- ZIP delivery estimate ---------- */
    var zipGo = root.querySelector("[data-eis-zip-go]");
    if (zipGo) {
      zipGo.addEventListener("click", function () {
        var input = root.querySelector("[data-eis-zip]");
        var out = root.querySelector("[data-eis-zip-out]");
        var z = (input.value || "").trim();
        if (!/^\d{5}$/.test(z)) { out.textContent = "Enter a 5-digit ZIP code."; return; }
        var d = new Date();
        d.setDate(d.getDate() + (parseInt(z[0], 10) > 5 ? 5 : 3));
        out.textContent = "Arrives by " +
          d.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" }) + ".";
      });
    }

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-eis-consumable]"), init);
  }

  document.addEventListener("DOMContentLoaded", boot);
  // Theme editor: re-init when the section is redrawn.
  document.addEventListener("shopify:section:load", function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll("[data-eis-consumable]"), init);
  });
  if (document.readyState !== "loading") boot();
})();